import { Divider, Typography } from "@mui/material";

const Title = () => {
  return (
    <>
      <Typography variant="h4" gutterBottom fontWeight={700}>
        Privacy Policy
      </Typography>
      <Typography variant="body1" sx={{ fontSize: "1.1rem" }}>
        This Privacy Policy (“Policy”) explains how <b>Keel Info Solution</b>, having
        its registered office in Chennai, Tamil Nadu, India, collects, uses,
        stores, processes and protects personal and employment-related
        information through the <b>Soucient HRMS </b> application(“Application”). This
        Policy applies to all employees who access or use the Application in any
        capacity.
      </Typography>
      <Typography variant="body1" sx={{ fontSize: "1.1rem", mt: 3 }}>
        By accessing or using Soucient HRMS, you acknowledge that you have read,
        understood and agreed to the practices described in this Privacy Policy.
      </Typography>

      <Divider sx={{ my: 2 }} />
    </>
  );
};

export default Title;
